<template>
  <div class="right-cont">
    <div class="page-name help-detail-top">关于我们</div>
    <div class="help-detail-right" v-html="content"></div>
  </div>
</template>

<script>
import { getListByTypeCode } from "@/http/user_center";

export default {
  name: "AboutUs",
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getListByTypeCode({ type_code: "guanyuwomen" }).then((res) => {
        this.content = res.data.guanyuwomen;
      });
    },
  },
}
</script>

<style scoped src="../../assets/css/user_center.css"></style>
